import {
  Button,
  Card,
  Checkbox,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  TextField,
  InputAdornment,
} from '@material-ui/core/';
import SearchIcon from '@material-ui/icons/Search';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {i18n2} from '../../../features/i18n/i18n';
import {SET_FILTER_ADD_ASSISTANT} from '../types/types';
import {Check, Close} from '@material-ui/icons';

const CustomList = ({elements}: any) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [filter, setFilter] = useState<
    Array<{
      columnName: string;
      operation: string;
      value: any;
      fromList: boolean;
    }>
  >([]);
  const [checked, setChecked] = useState<number[]>([]);
  const [search, setSearch] = useState('');

  const normalizedSearch = search.toLowerCase().trim();

  const filteredElements = elements.filter((e: any) =>
    e.name
      ?.toLowerCase()
      .split(' ')
      .some((word: string) => word.startsWith(normalizedSearch)),
  );

  const addAllSectors = () => {
    setChecked(elements);
    let newFilters: any = [];
    elements.forEach((value: any) => {
      newFilters.push({
        columnName: 'iD_Sector',
        operation: '=',
        value: value.iD_Sector,
        fromList: true,
      });
    });
    setFilter(newFilters);
  };

  const removeAllSectors = () => {
    setChecked([]);
    setFilter([]);
  };

  useEffect(() => {
    updateFilter(filter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  const updateFilter = (filter: any) => {
    dispatch({type: SET_FILTER_ADD_ASSISTANT, payload: filter});
  };

  const handleToggle = (value: any) => () => {
    const newFilters = [...filter];
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newFilters.push({
        columnName: 'iD_Sector',
        operation: '=',
        value: value.iD_Sector,
        fromList: true,
      }); //Este es para el FILTRO
      newChecked.push(value);
    } else {
      newFilters.splice(currentIndex, 1);
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
    setFilter(newFilters);
  };

  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}>
        <Typography variant="h6" className={classes.title}>
          {i18n2._('Sectores')}
        </Typography>

        <div className={classes.actions}>
          <Button
            variant="outlined"
            className={classes.btnAdd}
            size="small"
            onClick={addAllSectors}>
            <Check fontSize="small" />
          </Button>

          <Button
            variant="outlined"
            className={classes.btnDelete}
            size="small"
            onClick={removeAllSectors}>
            <Close fontSize="small" />
          </Button>
        </div>
      </div>
      <TextField
        variant="outlined"
        size="small"
        fullWidth
        placeholder={i18n2._('Buscar sector')}
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className={classes.search}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          ),
        }}
      />
      <Card style={{height: '74vh', width: 'auto', overflowY: 'scroll'}}>
        <List dense component="div" role="list">
          {filteredElements.length !== 0
            ? filteredElements.map((value: any, ix: number) => {
                const labelId = `checkbox-list-label-${value.iD_Sector}`;
                return (
                  <ListItem
                    key={ix}
                    role={undefined}
                    dense
                    button
                    onClick={handleToggle(value)}>
                    <ListItemIcon>
                      <Checkbox
                        edge="start"
                        checked={checked.indexOf(value) !== -1}
                        tabIndex={-1}
                        disableRipple
                        inputProps={{'aria-labelledby': labelId}}
                      />
                    </ListItemIcon>
                    <ListItemText id={labelId} primary={value.name} />
                  </ListItem>
                );
              })
            : null}
        </List>
      </Card>
    </>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(1),
    },
    actions: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    btnAdd: {
      fontWeight: 600,
      color: '#1C4257',
      borderColor: '#1C4257',
      backgroundColor: 'rgba(21, 101, 192, 0.1)',
      minWidth: 40,
      marginRight: theme.spacing(1),
      '&:hover': {
        backgroundColor: 'rgba(21, 101, 192, 0.25)',
        borderColor: '#0D47A1',
      },
    },
    btnDelete: {
      fontWeight: 600,
      color: '#8B0000',
      borderColor: '#8B0000',
      backgroundColor: 'rgba(139, 0, 0, 0.1)',
      minWidth: 40,
      '&:hover': {
        backgroundColor: 'rgba(139, 0, 0, 0.25)',
        borderColor: '#600000',
      },
    },
    search: {
      marginBottom: theme.spacing(1),
    },
  }),
);
export default CustomList;
